import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { ReactComponent as ChevronRightIcon } from "../../../assets/images/btn-right-aero.svg";
import { allowedNames, allowedRolesForFree } from "../../../constants";
import ComparisonModal from "../../restriction-modals/ComparisonModal";
import { FiX } from "react-icons/fi";
import {
  getRoles,
  getViewProfile,
  updateProfile,
} from "../../../redux/slices/profileSlice";
import { useDispatch, useSelector } from "react-redux";
import { activityStart, activityEnd } from "../../../redux/slices/trackActivitySlice";

const RoleSelectionModal = ({ show, onHide, selectedRole }) => {
  const [localRole, setLocalRole] = useState(selectedRole || "");
  const dispatch = useDispatch();

  const store = useSelector((state) => state.profile);
  const authStore = useSelector((state) => state.auth);

  const [subAlertVisible, setSubAlertVisible] = useState(false);
  const [subText, setSubText] = useState({});

  useEffect(() => {
    if (show) {
      setLocalRole(selectedRole || "");
    }
  }, [show, selectedRole]);

  useEffect(() => {
    dispatch(getRoles());
  }, [dispatch]);

  const currentPlan =
    authStore?.user?.plan?.name ||
    store?.profileItem?.data?.plan?.name ||
    "Free";

  const getRoleRestriction = (roleName) => {
    if (currentPlan === "Free") {
      if (!allowedRolesForFree.includes(roleName)) {
        return "Pro";
      }
    }

    return null;
  };
  
  const onSubmit = () => {
    if (!localRole) return;

    dispatch(
      updateProfile({
        current_role_id: localRole.id.toString(),
        name: store?.profileItem?.data?.full_name,
      }),
    );
  };

  useEffect(() => {
    if (store?.actionFlag === "PROFILE_UPDT_SCS") {
      onHide();
    }
  }, [store?.actionFlag, onHide]);


  useEffect(() => {
    if (!show) return;

    // Modal opened — start a tracking session
    dispatch(activityStart({ page_name: "UPDATE_CURRENT_ROLE", platform: "web" }));

    return () => {
      // Modal closed — end the session (duration recorded in seconds)
      dispatch(activityEnd({ page_name: "UPDATE_CURRENT_ROLE" }));
    };
  }, [show, dispatch]);
  useEffect(() => {
    if (show) {
      // dispatch(getViewProfile());
    }
  }, [show, dispatch]);
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">What best describes your current role?</h5>
        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <div className="radio-options">
          <div className="row">
            {store?.roleItems?.data?.describe_roles?.map((role) => {
              const requiredPlan = getRoleRestriction(role.name);
              const isSelected = localRole?.id === role.id;

              return (
                <div
                  key={role.id}
                  className={`radio-option col-lg-6
                    ${isSelected ? "selected" : ""}
                    ${requiredPlan ? "disabled-role" : ""}
                  `}
                  onClick={() => {
                    if (requiredPlan) {
                      setSubText({
                        header: "Subscription Required!",
                        desc2: "You need a Pro plan to unlock this role",
                        promassage:
                          "Pro users see all 9 nursing roles, including NP, CRNA, and Midwife",
                        propricem: "$2.99/month",
                        propricey: "$29.99/year",
                        plan: "Pro",
                        lockedItemName: role.name,
                      });
                      setSubAlertVisible(true);
                      return;
                    }

                    setLocalRole(role);
                  }}
                >
                  <div className="contentwrap">
                    <input
                      type="radio"
                      name="role"
                      checked={isSelected}
                      readOnly
                      disabled={!!requiredPlan}
                    />
                    <label className="radio-label" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flex: 1, gap: "8px" }}>
                      <span>{role.name}</span>
                      {requiredPlan && (
                        <span style={{
                          flexShrink: 0,
                          fontSize: "9px",
                          fontWeight: 800,
                          letterSpacing: "0.04em",
                          textTransform: "uppercase",
                          color: "var(--mmp-accent-hover)",
                          background: "var(--mmp-accent-bg)",
                          border: "1px solid var(--mmp-accent-border)",
                          borderRadius: "999px",
                          padding: "1px 6px",
                        }}>{requiredPlan}</span>
                      )}
                    </label>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="buttons text-center">
          <Button
            variant="primary"
            onClick={onSubmit}
            disabled={store?.isLoading || !localRole}
          >
            {store?.isLoading ? "Saving..." : "Save"}{" "}
            <ChevronRightIcon className="button-icon" />
          </Button>
        </div>
      </Modal.Body>

      <ComparisonModal
        title={subText.header}
        description={subText.desc}
        massage1={subText.massage1}
        pluspricem={subText.pluspricem}
        pluspricey={subText.pluspricey}
        prodesc={subText.desc2}
        promassage={subText.promassage}
        propricem={subText.propricem}
        propricey={subText.propricey}
        plan={subText.plan}
        lockedItemName={subText.lockedItemName}
        isVisible={subAlertVisible}
        onClose={() => setSubAlertVisible(false)}
        onPressYes={() => {
          setSubAlertVisible(false);
          onHide();
          window.location.href = "/profile/subscription";
        }}
        yesText="Upgrade Now"
        noText="Cancel"
        extraMetaInfo
      />
    </Modal>
  );
};

export default RoleSelectionModal;
